

















import { Component, Vue, PropSync } from "vue-property-decorator";

@Component
class DatePicker extends Vue {
  @PropSync("date") bindDate!: string;

  modal = false;

  handleOK() {
    const dialog: any = this.$refs.dialog;
    dialog.save(this.bindDate);
    this.modal = false;
  }

  handleReset() {
    this.modal = false;
  }
}
export default DatePicker;
